// BlogEditor.jsx
import { useState, useRef } from "react";
import { marked } from "marked";
import { saveAs } from "file-saver";
import PushToGitHub from "./pushToGitHub";

import hljs from "highlight.js";
import "highlight.js/styles/github.css";

marked.setOptions({
  highlight: (code, lang) => {
    try {
      return hljs.highlight(code, { language: lang || "javascript" }).value;
    } catch (e) {
      return hljs.highlightAuto(code).value;
    }
  },
});


export default function BlogEditor() {
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [image, setImage] = useState("");
  const [content, setContent] = useState("");
  const fileInputRef = useRef(null);

  function generateSlug(input) {
    return input.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  }

  const slug = generateSlug(title);
  const article = {
    title,
    subtitle,
    date,
    image: image || `/images/blog/${slug}.jpg`,
    content,
  };

  const handleSave = () => {
    const blob = new Blob([JSON.stringify(article, null, 2)], {
      type: "application/json;charset=utf-8",
    });
    saveAs(blob, `${slug}.json`);
  };

  const handleImageDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      const imagePath = `/images/blog/${file.name}`;
      setImage(imagePath);
    }
  };

  const handleCopyToClipboard = () => {
    const snippet = `📢 ${title}\n\n${subtitle}\n\n👉 Jetzt lesen: https://deine-domain.de/post/${slug}`;
    navigator.clipboard.writeText(snippet).then(() => {
      alert("✅ LinkedIn-Post kopiert!");
    });
  };

  return (
    <div className="max-w-6xl mx-auto p-6 grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="space-y-4">
        <h2 className="text-2xl font-bold">📝 Blogartikel erstellen</h2>

        <input
          type="text"
          placeholder="Titel"
          className="w-full border p-2 rounded"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input
          type="text"
          placeholder="Untertitel"
          className="w-full border p-2 rounded"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
        />
        <input
          type="date"
          className="w-full border p-2 rounded"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <input
          type="text"
          placeholder="/images/blog/deinbild.jpg"
          className="w-full border p-2 rounded"
          value={image}
          onChange={(e) => setImage(e.target.value)}
        />

        <div
          onDrop={handleImageDrop}
          onDragOver={(e) => e.preventDefault()}
          className="border-dashed border-2 border-gray-300 p-4 rounded text-center text-sm text-[#EFEBDC]0"
        >
          📂 Bild hierher ziehen (Dateiname wird übernommen)
        </div>

        <textarea
          placeholder="Markdown-Inhalt"
          className="w-full border p-2 h-64 rounded font-mono"
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />

        <div className="flex gap-4 flex-wrap">
          <button
            onClick={handleSave}
            className="bg-black text-slate-50 px-4 py-2 rounded hover:bg-gray-800"
          >
            💾 Als JSON speichern
          </button>

          <button
            onClick={handleCopyToClipboard}
            className="bg-blue-600 text-slate-50 px-4 py-2 rounded hover:bg-blue-700"
          >
            🔗 LinkedIn-Post kopieren
          </button>
        </div>

        <PushToGitHub content={article} defaultSlug={slug} />
      </div>

      <div>
        <h3 className="text-xl font-semibold mb-2">🔍 Vorschau</h3>
        <div
          className="prose prose-sm max-w-none border p-4 rounded"
          dangerouslySetInnerHTML={{ __html: marked.parse(content || "") }}
        />
      </div>
    </div>
  );
}
